import { PropsWithChildren } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { queryClient } from '@/lib/react-query';
import { ErrorBoundary } from '@/shared/components';
import { ScrollToTop } from '@/shared/components/ScrollToTop';
import env from '@/core/config/env';

/**
 * AppProviders
 * Composition of all context providers
 */
export const AppProviders = ({ children }: PropsWithChildren) => {
    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <ScrollToTop />
                    {children}
                </BrowserRouter>
                {env.ENABLE_DEV_TOOLS && <ReactQueryDevtools initialIsOpen={false} />}
            </QueryClientProvider>
        </ErrorBoundary>
    );
};
